import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { valueToCurrency } from '../../helpers/currencyHelper'
import colors from '../../lib/colors'
import { CurrencyCode } from '../../types/API'
import {
  GiftItemStatus,
  IColorTheme,
  IGiftItemResponse,
  SelectedPrice,
} from '../../types/itemTypes'
import { StateAction } from '../../types/typeAliases'
import { Buttons } from '../buttons/ItemButtonStyles'
import ItemPopup from './ItemPopup'
import PricesIncrement from './PricesIncrement'

const PriceRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`
const Title = styled.div`
  margin: 0 6px;
  div {
    color: ${colors.darkerGray};
  }
  h3 {
    font-size: 1rem;
    margin: 1px 0 1px 0;
  }
`
const Price = styled.div`
  cursor: default;
  border: 1px solid ${colors.gray};
  display: flex;
  align-items: center;
  min-width: 70px;
  justify-content: center;
`
interface IPricesProps {
  giftItem: IGiftItemResponse
  showPrices: boolean
  setShowPrices: StateAction<boolean>
  embedMode: boolean
  currency: CurrencyCode
  colorTheme: IColorTheme
  pricesSelected: SelectedPrice[]
  setPricesSelected: StateAction<SelectedPrice[]>
}
export default function Prices(props: IPricesProps): ReactElement | null {
  const {
    giftItem,
    showPrices,
    setShowPrices,
    embedMode,
    currency,
    colorTheme,
    pricesSelected,
    setPricesSelected,
  } = props
  const {
    prices, quantity, quantitySold, maxPerOrder,
  } = giftItem

  const totalQuantity = pricesSelected.reduce(
    (total, { count }) => total + count,
    0,
  )

  const remaining = (quantity
    && (quantitySold || quantitySold === 0)
    && quantity - quantitySold)
    || null

  const overRemaining = (remaining || remaining === 0) && totalQuantity >= remaining
  const overMax = maxPerOrder && totalQuantity >= maxPerOrder
  const over100 = !maxPerOrder && totalQuantity >= 100
  const atIncrementLimit = overMax || overRemaining || over100

  if (!prices || prices.length < 1) return <div>No prices found</div>

  const renderPrices = prices.map((price) => {
    if (price.status !== GiftItemStatus.Published) return null

    const thisSelectedCount = pricesSelected.find(
      (each) => each.id === price.id,
    )?.count

    const handleCount = (count: number): void => {
      setPricesSelected((p) => {
        const updated = [...p]
        const index = p.findIndex(({ id }) => id === price.id)

        updated[index].count = count
        return updated
      })
    }

    return (
      <PriceRow key={price.id}>
        <Title>
          <div>Ticket type:</div>
          <h3>{price.name}</h3>
        </Title>
        <Buttons>
          <Price>{valueToCurrency(price.value, currency)}</Price>
          <PricesIncrement
            colorTheme={colorTheme}
            atIncrementLimit={atIncrementLimit}
            count={thisSelectedCount}
            onChange={handleCount}
          />
        </Buttons>
      </PriceRow>
    )
  })

  return (
    <ItemPopup
      showPopup={showPrices}
      setShowPopup={setShowPrices}
      embedMode={embedMode}
    >
      {renderPrices}
    </ItemPopup>
  )
}
